module.exports = __webpack_public_path__ + "img/exhibition4.dafa5197.png";